import { render, staticRenderFns } from "./uvc.vue?vue&type=template&id=111c2322&scoped=true&"
import script from "./uvc.vue?vue&type=script&lang=js&"
export * from "./uvc.vue?vue&type=script&lang=js&"
import style0 from "./uvc.vue?vue&type=style&index=0&id=111c2322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111c2322",
  null
  
)

export default component.exports